import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { KustoLinkedService } from 'app/model/linkedservice/kusto.linkedservice';
import { Dataset } from './dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.kusto.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Kusto_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Kusto_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: KustoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class KustoDataset extends Dataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
